import { FORM_BUILDER_FIELD_TYPE } from "@loanbossinc/component-library";
import { ASSET_CLASS, ASSET_TYPE, ZONING, METROPOLITAN_STATISTICAL_AREA, STATES, REGION, MARKET_VALUE_METHODOLOGY } from "constants/configItemParents";

export const rows = {
  /*
   * address: {
   *   label: 'Address',
   *   cells: [
   *     { type: FORM_BUILDER_FIELD_TYPE.STRING , name: "address" , variant: "filled", style: {width: "100%"}},
   *     { type: FORM_BUILDER_FIELD_TYPE.STRING , name: "city" , variant: "filled", style: {width: "38%", marginLeft: "0", marginTop: "41px"} },
   *     {
   *       type: FORM_BUILDER_FIELD_TYPE.TYPEAHEAD,
   *       key: "state",
   *       name: "stateId",
   *       variant: "filled",
   *       parentId: STATES,
   *       options: [],
   *       displayWith: (option) => option.name,
   *       setValueWith: (option) => option.id,
   *       onChange: (id, value) => { console.log("onChange", {id});},
   *       style: {width: "35%", marginLeft: "16px", marginTop: "41px"}
   *     },
   *     { type: FORM_BUILDER_FIELD_TYPE.STRING , name: "zip" , variant: "filled", style: {width: "21%", marginTop: "41px"} },
   *   ]
   * },
   */
  noiActual: {
    label: "NOI (Actual)",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.DOLLAR,
        name: "noiActual",
        variant: "filled"
      }
    ]
  }
  /*
   * noi: {
   *   label: 'NOI (Lender)',
   *   cells: [
   *     {
   *       type: FORM_BUILDER_FIELD_TYPE.DOLLAR
   *       , name: "noi"
   *       , variant: "filled"
   *     }
   *   ]
   * },
   * occupancy: {
   *   label: 'Occupancy',
   *   cells: [
   *     {
   *       type: FORM_BUILDER_FIELD_TYPE.PERCENT
   *       , name: "occupancy"
   *       , variant: "filled"
   *       , decimals: 2
   *     }
   *   ]
   * },
   * marketValue: {
   *   label: 'Market Value',
   *   cells: [
   *     {
   *       type: FORM_BUILDER_FIELD_TYPE.DOLLAR
   *       , name: "marketValue"
   *       , variant: "filled"
   *     }
   *   ]
   * }
   */
};
